import React from 'react';
import styled from 'styled-components';
import {
  FiCopy, FiMove, FiTrash2, FiRotateCw, FiChevronsRight, FiRepeat,
} from 'react-icons/fi';

const Bar = styled.div`
  position: absolute;
  left: 12px;
  bottom: 58px;
  z-index: 14;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
  border-radius: 10px;
  background: rgba(17, 24, 39, 0.94);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.35);
`;

const Btn = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  border: none;
  border-radius: 8px;
  padding: 8px 10px;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
  color: ${(p) => (p.$active ? '#fff' : '#d1d5db')};
  background: ${(p) => (p.$active ? '#2563eb' : 'transparent')};

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    background: ${(p) => (p.$active ? '#1d4ed8' : 'rgba(255,255,255,0.1)')};
    color: #fff;
  }
`;

export default function ContextModifyBar({
  visible,
  modifyMode,
  canOffset = true,
  onMove,
  onCopy,
  onDelete,
  onRotate,
  onFreeRotate,
  onMirror,
  onOffsetModeToggle,
}) {
  if (!visible) return null;

  return (
    <Bar role="toolbar" aria-label="Modify object">
      <Row>
        <Btn type="button" $active={modifyMode === 'move'} onClick={onMove} title="Move (or Ctrl+drag)">
          <FiMove size={14} />
          Move
        </Btn>
        <Btn type="button" onClick={onCopy} title="Duplicate in place (or Alt+drag to place copy)">
          <FiCopy size={14} />
          Copy
        </Btn>
        <Btn
          type="button"
          $active={modifyMode === 'rotate'}
          onClick={onFreeRotate}
          title="Free rotate — click pivot, then drag angle (Shift = 15° snap)"
        >
          <FiRotateCw size={14} />
          Rotate
        </Btn>
        <Btn type="button" onClick={() => onRotate?.(90)} title="Rotate 90° clockwise">
          90°
        </Btn>
        <Btn
          type="button"
          $active={modifyMode === 'mirror'}
          onClick={onMirror}
          title="Mirror — click axis through shape vertices · hold C = copy"
        >
          <FiRepeat size={14} />
          Mirror
        </Btn>
        <Btn
          type="button"
          $active={modifyMode === 'offset'}
          disabled={!canOffset}
          onClick={onOffsetModeToggle}
          title="Parallel offset — hover shape, pick arrow · hold C = copy"
        >
          <FiChevronsRight size={14} />
          Offset
        </Btn>
        <Btn type="button" onClick={onDelete} title="Delete">
          <FiTrash2 size={14} />
          Delete
        </Btn>
      </Row>
    </Bar>
  );
}
